import React from 'react';
import Svg from "@/Components/Svg";

export default function Logo() {
    const Component = (<Svg id={`main-logo`} className={`svg__mainLogo`} />);

    // // Подготовка под редизайн
    // const Component = isDesktop()
    //     ? (<Svg id={`main-logo`} className={`svg__mainLogo`} />)
    //     : (<Svg id={`main-logo-mobile`} className={`svg__mainLogoMobile`} />);

    return (
        Component
    );
}
